import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e26d4e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " 👌 Les nouveautés ", -1))
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "h6 mb-1" }
const _hoisted_4 = { class: "small" }
const _hoisted_5 = { class: "text-primary fw-bold small" }

import AffiliateCampaign from '@/tmp/src/entities/affiliate/affiliateCampaign';
import ItemWithThumbnail from '@/atomic/molecules/ItemWithThumbnail.vue';
import { useIonRouter } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftRowNewArrivals',
  props: {
  gifts: {
    type: Array<AffiliateCampaign>,
    required: true,
  },
},
  setup(__props) {

const router = useIonRouter();



function getPictureUrl(gift: AffiliateCampaign) {
  if (!gift.picture) {
    return 'https://ionicframework.com/docs/img/demos/card-media.png';
  }
  if (import.meta.env.MODE === 'development') {
    return `http://localhost:1337${gift.picture}`;
  }
  return `https://api.petitcitron.fr${gift.picture}`;
}
const goToGiftPreview = (gift: AffiliateCampaign) => {
  router.push(`/gifts/preview/${gift.id}`);
};

return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, { class: "my-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, { size: "12" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.gifts, (gift) => {
        return (_openBlock(), _createBlock(_component_ion_col, {
          key: `new-campaign-${gift.id}`,
          size: "10",
          offset: "1",
          onClick: ($event: any) => (goToGiftPreview(gift))
        }, {
          default: _withCtx(() => [
            _createVNode(ItemWithThumbnail, {
              "image-source": getPictureUrl(gift)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(gift.title), 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(gift.offer), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(gift.cost) + " 🍋 ", 1)
                ])
              ]),
              _: 2
            }, 1032, ["image-source"])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})